module.exports = __webpack_public_path__ + "assets/pdf/場地申請表格.pdf";